import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';

// Components
import App from './components/App/App';

// Store
import store from './store/store';

// Configs
import { muiTheme } from './configs/muiStyling.config';

const container = document.getElementById('admin-2-estimates-component');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <ThemeProvider theme={muiTheme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ThemeProvider>
);
